"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDate = exports.assignGetSet = exports.defaultCamelCaseObject = exports.defaultObject = exports.defaultEnum = exports.defaultArray = exports.defaultBoolean = exports.defaultFloat = exports.defaultNumber = exports.defaultString = exports.makeDate = exports.snakeToCamel = void 0;
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
const snakeToCamel = (key) => key.toLowerCase().replace(/([_][a-z])/gi, $1 => $1.toUpperCase().replace('_', ''));
exports.snakeToCamel = snakeToCamel;
const makeDate = (date, extra = 0) => {
    let newDate = new Date();
    if (typeof date === 'string') {
        const momentDate = moment_1.default(date, 'YYYY-MM-DD');
        momentDate.add(extra, 'd');
        newDate = momentDate.toDate();
    }
    else if (date instanceof Date) {
        newDate = date;
    }
    return newDate;
};
exports.makeDate = makeDate;
const defaultString = (value) => (value ? value.toString() : '');
exports.defaultString = defaultString;
const defaultNumber = (value) => {
    if (value) {
        const num = parseInt(value.toString(), 10);
        if (lodash_1.default.isFinite(num)) {
            return num;
        }
    }
    return 0;
};
exports.defaultNumber = defaultNumber;
const defaultFloat = (value) => {
    if (value) {
        const num = parseFloat(value.toString());
        if (lodash_1.default.isFinite(num)) {
            return num;
        }
    }
    return 0;
};
exports.defaultFloat = defaultFloat;
const defaultBoolean = (value) => !!value;
exports.defaultBoolean = defaultBoolean;
const defaultArray = (value) => {
    let list = [];
    if (Array.isArray(value)) {
        list = value;
    }
    else if (value) {
        list = [value];
    }
    return list;
};
exports.defaultArray = defaultArray;
function defaultEnum(value, enumObj) {
    return Object.values(enumObj).indexOf(value) > -1 && value !== null && value !== undefined
        ? value
        : '';
}
exports.defaultEnum = defaultEnum;
const defaultObject = (value) => lodash_1.default.isPlainObject(value) && value ? value : {};
exports.defaultObject = defaultObject;
function defaultCamelCaseObject(value) {
    const obj = {};
    if (value) {
        Object.keys(value).forEach(key => {
            const currentValue = value[key];
            obj[exports.snakeToCamel(key)] = currentValue;
        });
    }
    return obj;
}
exports.defaultCamelCaseObject = defaultCamelCaseObject;
const assignGetSet = (model, { snake, camel, get, set, } = {
    snake: '', camel: '', get: null, set: null,
}) => {
    Object.defineProperty(model.prototype, camel, {
        enumerable: true,
        configurable: true,
        // @ts-ignore
        get: get || function () { return this[snake]; },
        set: set || function (value) {
            // @ts-ignore
            this[snake] = value;
            // @ts-ignore
            return this;
        },
    });
};
exports.assignGetSet = assignGetSet;
const defaultDate = (date, extra = 0) => {
    let newDate = new Date();
    if (typeof date === 'string') {
        const momentDate = moment_1.default(date, 'YYYY-MM-DD hh:mm');
        momentDate.add(extra, 'd');
        newDate = momentDate.toDate();
    }
    else if (date instanceof Date) {
        newDate = date;
    }
    return newDate;
};
exports.defaultDate = defaultDate;
exports.default = {
    defaultBoolean: exports.defaultBoolean,
    defaultCamelCaseObject,
    defaultEnum,
    defaultFloat: exports.defaultFloat,
    defaultNumber: exports.defaultNumber,
    defaultObject: exports.defaultObject,
    defaultString: exports.defaultString,
    assignGetSet: exports.assignGetSet,
    defaultDate: exports.defaultDate
};
